import DefaultElementNodeType from '../DefaultElementNodeType';
import {APPLICATION_COLLABORATION} from '../../metamodel/Concept';

export default class ApplicationCollaborationNodeType extends DefaultElementNodeType {
	static get typeName() {
		return APPLICATION_COLLABORATION;
	}
}
